import { isArchive, ITEM_TYPES, itemIsPlaying } from 'Utils/index';
import { ContinueWatchingItem, ContinueWatchingModel, modelType } from '@24i/st-api-connector';
// eslint-disable-next-line import/no-unresolved
import { PlayerData } from 'Types';
import appManager from 'AppManager';
import { useStore } from 'Store';
import { RECORDING_BINGE_WATCHING_DAYS_LIMIT } from '../../../options';

export const isSeriesTypeLike = (item: PlayerData['item']) =>
    item.modelType === modelType.season ||
    item.modelType === modelType.series ||
    item.modelType === modelType.episode;

export const shouldHaveContinueWatching = (
    item: PlayerData['item'],
    offline = false,
    isTrailer = false
): boolean => (!offline &&
    !isTrailer &&
    !itemIsPlaying(item) &&
    (isArchive(item) ||
        item.modelType === modelType.vod ||
        item.modelType === modelType.recording ||
        item.modelType === modelType.recordingSeries ||
        isSeriesTypeLike(item)));

export const canUseBingeWatching = (item: PlayerData['item']): boolean => {
    if (
        item.modelType !== modelType.recording &&
        item.modelType !== modelType.recordingSeries &&
        item.modelType !== modelType.vod
    )
        return false;

    const itemStartTime = 'getStartTime' in item ? item.getStartTime() : null;
    if (!itemStartTime) return false;

    const thresholdDate = new Date(itemStartTime);
    thresholdDate.setDate(thresholdDate.getDate() - RECORDING_BINGE_WATCHING_DAYS_LIMIT);
    if (itemStartTime >= thresholdDate.getTime()) return true;

    const itemSerieId = 'getSeriesId' in item ? item.getSeriesId() : null;
    if (itemSerieId) return true;

    return false;
};

export const checkContinueWatching = async (
    item: PlayerData['item']
): Promise<ContinueWatchingItem | null> => {
    let match: ContinueWatchingModel | null = null;
    if (shouldHaveContinueWatching(item)) {

        try {
            const { items } = await appManager.getApi().fetchContinueWatching();
            if (items && items.length > 0) {
                match = items.find((continueWatchItem) => {
                    if (continueWatchItem.data.type === 'PVR') {
                        return continueWatchItem?.data?.scheduleId === item.getId();
                    }

                    return continueWatchItem?.data?.id === item.getId();
                });
            }
        } catch (error) {
            console.log(error);
        }
    }

    return match ? match.getRawData() : null;
};

// remove
// export const getPlayerComponentByItem = (item, offline = false, isTrailer = false) => {
//     let PlayerComponent = Player;

//     if (isSeriesTypeLike(item) || canUseBingeWatching(item)) {
//         PlayerComponent = withBingeWatching(PlayerComponent);
//     }

//     if (item.modelType === modelType.tv) {
//         PlayerComponent = withLivePlayer(Player);
//         if (isArchive(item)) {
//             PlayerComponent = withBingeWatching(PlayerComponent);
//         }
//     }

//     if (shouldHaveContinueWatching(item, offline, isTrailer)) {
//         PlayerComponent = withContinueWatching(PlayerComponent);
//     }

//     return PlayerComponent;
// };
